enum EHeaders {
    CONTENT_TYPE = 'Content-Type',
}

export default EHeaders
